import PaymentComponent from '../components/payment/payment'

const Payment = () => <PaymentComponent />

export default Payment;